import moment from "moment";
import API from "../../../utils/helpers/API.helpers";
import { removeKeysWithNullValues } from "../../../utils/helpers/common.helpers";

const ProfileService = {
  async getMahasiswaInfo() {
    return await API.get({ endpoint: "/mahasiswa/user-info" });
  },
  async updateMahasiswaInfo(mahasiswaDetails) {
    let parsed = parseUpdateMahasiswaDetails(mahasiswaDetails);
    let nullRemoved = removeKeysWithNullValues(parsed);
    return await API.put({ endpoint: "/mahasiswa/edit", data: nullRemoved });
  },
  async getDosenInfo() {
    return await API.get({ endpoint: "/dosen/user-info" });
  },
};

const parseUpdateMahasiswaDetails = (mahasiswaDetails) => {
  return {
    ...mahasiswaDetails,
    angkatan: mahasiswaDetails.angkatan
      ? parseInt(mahasiswaDetails.angkatan)
      : null,
    email_non_ui: mahasiswaDetails.email_non_ui,
    no_hp: mahasiswaDetails.no_hp,
    url_linkedin: mahasiswaDetails.url_linkedin,
    tanggal_lahir: mahasiswaDetails.tanggal_lahir
      ? moment.isMoment(mahasiswaDetails.tanggal_lahir)
        ? mahasiswaDetails.tanggal_lahir.format("YYYY-MM-DD")
        : mahasiswaDetails.tanggal_lahir
      : null,
    domisili: mahasiswaDetails.domisili,
    tanggal_mulai_kerja: mahasiswaDetails.tanggal_mulai_kerja
      ? moment.isMoment(mahasiswaDetails.tanggal_mulai_kerja)
        ? mahasiswaDetails.tanggal_mulai_kerja.format("YYYY-MM-DD")
        : mahasiswaDetails.tanggal_mulai_kerja
      : null,
  };
};

export default ProfileService;
